import { createAction, props } from '@ngrx/store';

export const saveLoginOrigin = createAction('[App] save login origin', props<{ origin: string }>());
export const saveCustomerConfig = createAction('[App] save customer config', props<{ config: any }>());
export const saveEnvironments = createAction('[App] save environments', props<{ environments: any }>());
export const saveApplicationWiseCapabilities = createAction('[App] save application wise capabilities', props<{ applicationId: number, capabilities: any }>());
export const saveAbbreviations = createAction('[App] save abbreviations', props<{ abbreviations: any }>());
export const clearAppState = createAction('[App] Clear app state');